import React from "react";
import { Link } from 'react-router-dom'
import BlockColorCode from "../../Devices/DevServices/BlockColorCode"

const SPr_01a_Devs = (props) => {
    const {data, onlineContent} = props
    //console.log(data)
    if (!data) return null
    return (
/*       <div className="container mt-1">
      <table className="table table-striped">
          <thead>
              <tr>
                  <th>ID</th>
  
                  <th>Desk Name</th>
                  <th>qty</th>
                  <th>Online</th>
                  <th>Mobile</th>
  
              </tr>
          </thead>
          <tbody>
            {
              data.map((v,i) => {
                return (
                  <tr key={`desk_${i}`}>
                  <td><Link to={`/selected_desk/${v.id}`}>{v.id}</Link></td>
                  <td><Link to={`/selected_desk/${v.id}`}><span className="text-secondary">{v.desk_name}</span></Link></td>
                  <td>{v.dev_qty}</td>
                  <td>
                  {onlineContent(v.dev_online)}
                  </td>
                  <td><Link to={`/selected_desk_mobile/${v.id}`}>test</Link></td>
      
                </tr>
                )
              })
            }
  
          </tbody>
      </table>
  </div> */

        <div className="list-group">
          {data.map((v, index) => (
            <div 
              key={v.id}
              className={`list-group-item ${index % 2 === 0 ? 'bg-light' : 'bg-white'} p-1 mb-2 rounded`}
            >
              {/* Display key-value pairs with pictograms */}
              <div className="d-flex align-items-center gap-2">

  
              <span style={{ fontSize: '0.9rem' }}>
                id: {v.id} | 
                <span className="text-decoration-underline ms-1">
                  Desk: 
                  <Link to={`/selected_desk_mobile/${v.id}`} className="text-secondary ms-1">
                    {v.desk_name}
                  </Link>
                </span>
              </span>
              <div className="d-inline-block">
                <BlockColorCode
                  project_color_code={v.desk_color_code}
                  dataName="desk_color_code"
                />
              </div>
            </div>

            </div>
          ))}
        </div>

    )
  }

  export default SPr_01a_Devs